import React, { Component } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";

import createStore from "./createStore";

const store = createStore();

// The provider, which holds the page-wide store and its actions.
// Feel free to abstract actions and state away from this file.
class AppProvider extends Component {
  render() {
    return <Provider store={store}>{this.props.children}</Provider>;
  }
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppProvider;
